module.exports = __webpack_public_path__ + "img/icon_cards.2c739722.svg";